import { render, staticRenderFns } from "./EducationalGroupChooseAddType.vue?vue&type=template&id=eb05ed1e&"
import script from "./EducationalGroupChooseAddType.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupChooseAddType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports